import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@brunata-angular/util';

@Pipe({
    name: 'appnumber',
    standalone: true,
})
export class NumberPipe implements PipeTransform {
    private numberFormat: Intl.NumberFormat;

    constructor(private translateService: TranslateService) {
        this.numberFormat = new Intl.NumberFormat(translateService.language, {
            maximumSignificantDigits: 21,
        });
    }

    transform(value: number | null | undefined, minDigits?: number, maxDigits?: number): string {
        if (value == null || isNaN(value)) {
            return '';
        } else if (minDigits != null) {
            return new Intl.NumberFormat(this.translateService.language, {
                minimumFractionDigits: minDigits,
                maximumFractionDigits: maxDigits ?? minDigits,
            }).format(value);
        } else {
            return this.numberFormat.format(value);
        }
    }
}
